



























































































































































































import { Vue, Component } from "vue-property-decorator";
import {
  getMarketStaffListApi,
  exportMarketStaffListApi,
} from "@/api/marketActivity";
import { dateFormat } from "@/utils/timeFormat";
import { exportLoop } from "@/utils/export";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "salesAmountDetail",
  components: {
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo: any = {
    status: -1,
    full_time: -1,
    sort_field: "create_time",
    sort_type: "desc",
  };
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  tableData: any[] = [];
  market_staff_list: any[] = [];
  effectiveDate: any = {
    disabledDate(date: any) {
      return date > Date.now();
    },
  };
  timer: any = "";

  created() {
    this.getList();
    this.getMarketStaffListApiFn();
  }
  solveSearchInfo(option: any) {
    let params = { ...option };
    if (this.searchInfo.market_staff_id) {
      params.market_staff_id = this.searchInfo.market_staff_id;
    }
    if (this.searchInfo.status > 0) {
      params.status = this.searchInfo.status;
    }
    if (this.searchInfo.full_time > 0) {
      params.full_time = this.searchInfo.full_time;
    }
    if (this.searchInfo.create_time) {
      params.create_start_time =
        new Date(this.searchInfo.create_time[0] + " 00:00:01").getTime() / 1000;
      params.create_end_time =
        new Date(this.searchInfo.create_time[1] + " 23:59:59").getTime() / 1000;
    }
    if (this.searchInfo.sort_type) {
      params.sort_type = this.searchInfo.sort_type;
    }
    if (this.searchInfo.sort_field) {
      params.sort_field = this.searchInfo.sort_field;
    }
    return params;
  }
  getList(params?: any) {
    let option = this.solveSearchInfo(params);
    getMarketStaffListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.forEach((item: any) => {
          item.create_time = item.create_time
            ? dateFormat("YYYY-mm-dd HH:MM", new Date(item.create_time * 1000))
            : "-";
        });
        this.tableData = [
          {
            staff_id: "-",
            name: "官方",
            mobile: "-",
            full_time: 1,
            activity_num: res.data.official.activity_num,
            sales_amount: res.data.official.sales_amount,
            ongoing_activity_num: res.data.official.ongoing_activity_num,
            roster_num: res.data.official.roster_num,
            today_roster_num: res.data.official.today_roster_num,
            today_sales_amount: res.data.official.today_sales_amount || "0",
            create_time: res.data.official.create_time
              ? dateFormat(
                  "YYYY-mm-dd HH:MM",
                  new Date(res.data.official.create_time * 1000)
                )
              : "-",
            market_staff_status: 1,
            status: -1,
          },
          ...res.data.list,
        ];
        this.total = res.data.total;
      }
    });
  }

  // 获取市场顾问列表
  getMarketStaffListApiFn(v?: any) {
    getMarketStaffListApi({
      page: 1,
      page_size: 100,
      keyword: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.market_staff_list = res.data.list;
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  // 模糊搜索 - 市场顾问
  handleSearchMarketStaff(v: any) {
    this.debounce(this.getMarketStaffListApiFn, v, 500);
  }
  debounce(fn: any, data: any, delay: any) {
    // 设置一个触发开关
    let _t = this;
    clearTimeout(_t.timer);
    _t.timer = setTimeout(() => {
      fn(data);
    }, delay);
  }
  // 跳转推广名单
  handleToPromotionList(scope: any) {
    let query = {
      market_staff_id: scope.row.staff_id,
      name: scope.row.name,
    };
    if (scope.row.staff_id === "-") {
      query.market_staff_id = 0;
    }
    this.$router.push({
      name: "promotionList",
      query: query,
    });
  }
  // 跳转销售金额明细
  handleToSalesAmountDetail(scope: any) {
    let query = {
      market_staff_id: scope.row.staff_id,
      name: scope.row.name,
    };
    if (scope.row.staff_id === "-") {
      query.market_staff_id = 0;
    }
    this.$router.push({
      name: "salesAmountDetail",
      query: query,
    });
  }
  handleStaffStatus(scope: any) {
    if (scope.row.market_staff_status === 1) {
      return "正常";
    } else {
      if (scope.row.is_del === 2 && scope.row.status === 1) {
        return "调岗";
      } else {
        return "离职";
      }
    }
  }
  clickSort(e: { order: string; prop: string }) {
    let sort = "desc";
    if (e.order == "descending") {
      sort = "desc";
    } else if (e.order == "ascending") {
      sort = "asc";
    }
    this.searchInfo.sort_type = sort;
    this.searchInfo.sort_field = e.prop;
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  handleExport() {
    let option = this.solveSearchInfo({
      page: this.page,
      page_size: this.pageSize,
    });
    exportMarketStaffListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        console.log(res.data);
        exportLoop(res.data.task_id);
      }
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
